// HUD 영어 라벨. 노동부 대시보드(gov)도 영어는 이 값을 그대로 쓴다.
export const HUD_LABELS_EN = {
  title: '한국 미얀마 워커 송금 현황',
  subtitle: 'Ops HUD · Ministry of Labour · Real-time telemetry',
  live: 'Live Telemetry',
  liveShort: 'Live',
  offline: 'Offline',
  syncing: 'Syncing',
  fail: 'Fail {{n}}',
  period: 'Period',
  language: 'Lang',
  totalVolume: 'Total volume',
  totalVolumeSub: 'Settled remittance · USD',
  ledger: 'Ledger',
  allTime: 'All-time',
  today: 'Today throughput',
  todaySub: 'Daily processing volume',
  vsYesterday: 'vs yesterday',
  citizens: 'Registered citizens',
  citizensSub: 'Platform enrollment base',
  active: 'Active',
  workers: 'Workers',
  compliance: 'Policy compliance',
  complianceSub: 'Achievement rate',
  cleared: 'Cleared',
  pipeline: 'Remittance pipeline',
  pipelineSub: 'Hecto → bank → settlement',
  stageHecto: 'Hecto',
  stageBank: 'Receiving bank',
  stageDone: 'Completed',
  stageFail: 'Failed',
  badgeProcessing: 'Processing',
  badgePayout: 'Payout',
  badgeDone: 'Done',
  badgeAlert: 'Alert',
  inProgress: 'In progress',
  completed: 'Completed',
  attention: 'Attention',
  success: 'Success',
  throughput: 'Throughput telemetry',
  throughputSub: 'Remittance volume trend',
  volume: 'Volume (USD)',
  risk: 'Risk matrix',
  riskSub: 'Ops health radar',
  score: 'Score',
  feed: 'Corridor feed',
  feedSub: 'Latest remittance events',
  gateway: 'Gateway link',
  clearance: 'Clearance rate',
  awaiting: 'Awaiting corridor events',
  statusMix: 'Status mix',
  statusMixSub: 'Volume by pipeline state',
  processing: 'Processing',
  failed: 'Failed',
  enrollment: 'Enrollment',
  enrollmentSub: 'Citizen registration trend',
  newUsers: 'New Users',
  load: 'Pipeline load',
  loadSub: 'In-flight vs cleared',
  bank: 'Bank',
  done: 'Done',
  failShort: 'Fail',
};
